import { gql } from 'graphql-request';

export const GET_ALL_BLOCKCHAINS = gql`
  query GetAllBlockchains {
    blockchains(first: 50) {
      id
      blockchainName
      blockchainLogo
      icon {
        url
      }
      stakeNowButtonLink
      descriptionShort
      buttonStatus
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const GET_BLOCKCHAIN_BY_NAME = gql`
  query GetBlockchainByName($name: String!) {
    blockchains(where: { blockchainName: $name }) {
      id
      blockchainName
      blockchainLogo
      icon {
        url
      }
      stakeNowButtonLink
      descriptionShort
      buttonStatus
      sortOrder
      createdAt
      updatedAt
    }
  }
`;

export const GET_LIVE_BLOCKCHAINS = gql`
  query GetLiveBlockchains {
    blockchains(where: { buttonStatus: "available" }, first: 50) {
      id
      blockchainName
      blockchainLogo
      icon {
        url
      }
      stakeNowButtonLink
      descriptionShort
      buttonStatus
      sortOrder
    }
  }
`;

export const GET_SOCIAL_LINKS = gql`
  query GetSocialLinks {
    socialLinks(where: { isActive: true }, orderBy: sortOrder_ASC, first: 20) {
      id
      platform
      url
      icon {
        url
      }
      isActive
      sortOrder
      createdAt
      updatedAt
    }
  }
`;